import React, { useContext, useState, useRef } from 'react';

const AppContext = React.createContext();

export const AppProvider = ({ children }) => {
  const [isNavbarOpen, setIsNavbarOpen] = useState(false);
  const [isHovered, setIsHovered] = useState(false);

  const hoveredDiv = useRef(null);

  const closeNavbar = () => {
    setIsNavbarOpen(false);
    window.scrollTo(0, 0);
  };

  return (
    <AppContext.Provider
      value={{
        isNavbarOpen,
        setIsNavbarOpen,
        closeNavbar,
        isHovered,
        hoveredDiv,
        setIsHovered,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

export const useGlobalContext = () => {
  return useContext(AppContext);
};
